import React from "react";
import { IconType } from "react-icons";
import EndUserPublicLayout from "../atoms/EndUserPublicLayout";

type IconColor = "red" | "amber" | "green" | "indigo" | "gray";

const ICON_COLOR_CLASS: Record<IconColor, string> = {
  red: "text-red-400",
  amber: "text-amber-500",
  green: "text-green-500",
  indigo: "text-blue-500",
  gray: "text-gray-400",
};

type EndUserMessageCardProps = {
  Icon: IconType;
  iconColor?: IconColor;
  iconSize?: number;
  title: string;
  message: string;
  secondaryMessage?: string;
  children?: React.ReactNode;
};

const EndUserMessageCard: React.FC<EndUserMessageCardProps> = ({
  Icon,
  iconColor = "red",
  iconSize = 56,
  title,
  message,
  secondaryMessage,
  children,
}) => {
  return (
    <EndUserPublicLayout>
      <div className="flex flex-col items-center text-center gap-3">
        <Icon className={`${ICON_COLOR_CLASS[iconColor]}`} size={iconSize} />
        <h2 className="text-xl font-semibold text-gray-800">{title}</h2>
        <p className="text-sm text-gray-500">{message}</p>
        {secondaryMessage && (
          <p className="text-sm font-semibold text-gray-700">
            {secondaryMessage}
          </p>
        )}
        {children && <div className="mt-4 w-full">{children}</div>}
      </div>
    </EndUserPublicLayout>
  );
};

export default EndUserMessageCard;
